import Microsoft365Page from './microsoft365.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

/**
 * #1044 · Microsoft 365 · empleados existentes: diagnóstico y sincronización.
 *
 * Manda el menú de Mongo, como en todas las rutas: el lote `fase-m365-empleados-2026-10` de
 * movilidad da de alta `/microsoft365/` para ADMIN y DIRECTOR, que son los responsables de
 * `m365.seguridad.roles-gestion` en la API. Esa entrada es el único punto de entrada; y aunque alguien
 * llegara sin ella, la API responde 403 a quien no es responsable y la pantalla lo dice.
 */
export const RUTA_MICROSOFT365 = '/microsoft365/';
export const ROLES_MICROSOFT365 = ['ADMIN', 'DIRECTOR'];

const routes = [
    {
        path: RUTA_MICROSOFT365,
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('microsoft365', ROLES_MICROSOFT365, Microsoft365Page)
    }
];

export default routes;
